import { render, staticRenderFns } from "./ConnectionsHistoryTableAdmin.vue?vue&type=template&id=4c196520&scoped=true"
import script from "./ConnectionsHistoryTableAdmin.vue?vue&type=script&lang=js"
export * from "./ConnectionsHistoryTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c196520",
  null
  
)

export default component.exports